import Api from '@/services/Index';

const getAll = async (type) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/instructor/exam/requests/instructor-get-courses/${type}`);
};

const update = async (type, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/instructor/exam/requests/instructor-set-courses/${type}`, formData);
}

export default {getAll, update}
